export default __webpack_public_path__ + "alberta-imbibe-incontinence.a7e48bbd26aa3f6b8a1e.svg";